/** @jsxImportSource @theme-ui/core */

import React from 'react';
import { Button, ButtonProps } from 'antd';
import { BoxOwnProps } from 'theme-ui';

type Props = ButtonProps & {
  sx?: BoxOwnProps['sx'];
}
export const ActionButton: React.FC<Props> = ({ sx, ...props}) => (
  <Button {...props} type="primary" sx={{ width: '100%', height: 42, fontSize: 16, fontWeight: 'bold', ...sx }} />
);
